export enum PaymentStatus {
  None,
  Initiated,
  Pending,
  InProgress,
  Processing,
  Success,
  Failed,
  Completed,
}
